// Port of api/fuel/app/classes/insights/members/compare.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Rating from 'offline/model/rating'
import User from 'offline/model/user'
import Util from 'offline/util'

function membersCompareAnalysis(owner, userIndex, vars) {
	var user = vars.user ? parseInt(vars.user, 10) : false
	if (userIndex.length < 2) return []

	var groupedByGame = {}
	var groupedByUser = {}
	var relationships = {}
	var threshold = 16

	var filteredUsers = User.collection({
		where: [
			['user_id', 'in', userIndex],
			['user_count_ratings', '>=', threshold]
		]
	}).map(function(model) { return model.get_id() })

	var ratings = Rating.filter({
		arrayed: true,
		select: {
			plain: ['user_id', 'game_id', 'rating_value']
		},
		where: [
			['user_id', 'in', filteredUsers]
		]
	})

	for (var i = 0; i < ratings.length; i++) {
		var rating = ratings[i]
		var gameId = parseInt(rating.game_id, 10)
		var userId = parseInt(rating.user_id, 10)
		if (!groupedByGame[gameId]) groupedByGame[gameId] = []
		if (!groupedByUser[userId]) groupedByUser[userId] = []
		groupedByGame[gameId].push(rating)
		groupedByUser[userId].push(rating)
	}

	if (user) filteredUsers = [user]

	for (var fu = 0; fu < filteredUsers.length; fu++) {
		var currentUserId = parseInt(filteredUsers[fu], 10)
		if (!groupedByUser[currentUserId]) continue

		for (var ur = 0; ur < groupedByUser[currentUserId].length; ur++) {
			var userRating = groupedByUser[currentUserId][ur]
			var matches = groupedByGame[parseInt(userRating.game_id, 10)] || []
			for (var gr = 0; gr < matches.length; gr++) {
				var groupRating = matches[gr]
				if (parseInt(userRating.user_id, 10) === parseInt(groupRating.user_id, 10)) continue

				var a = Math.min(parseInt(userRating.user_id, 10), parseInt(groupRating.user_id, 10))
				var b = Math.max(parseInt(userRating.user_id, 10), parseInt(groupRating.user_id, 10))
				var relationshipKey = a + '/' + b

				if (!relationships[relationshipKey]) {
					relationships[relationshipKey] = {
						user_a: a,
						user_b: b,
						difference: 0,
						ratings: 0,
						games: {}
					}
					if (user) {
						relationships[relationshipKey].user_a = user
						relationships[relationshipKey].user_b = parseInt(groupRating.user_id, 10)
					}
				}

				var relatedGameId = parseInt(groupRating.game_id, 10)
				if (!relationships[relationshipKey].games[relatedGameId]) {
					relationships[relationshipKey].games[relatedGameId] = true
					relationships[relationshipKey].ratings++
					relationships[relationshipKey].difference += Math.abs(parseFloat(userRating.rating_value) - parseFloat(groupRating.rating_value))
					relationships[relationshipKey].average = relationships[relationshipKey].difference / relationships[relationshipKey].ratings
				}
			}
		}
	}

	return Object.keys(relationships).map(function(key) { return relationships[key] }).filter(function(relationship) {
		return relationship.ratings >= threshold
	})
}

function membersComparePackage(segment, relationships, detail, compareType) {
	var limit = detail ? 100 : 5
	var sorted = Util.sort_by_field(relationships, 'average', compareType === 'most' ? 'asc' : 'desc').slice(0, limit)
	for (var i = 0; i < sorted.length; i++) {
		segment._references.users.push(parseInt(sorted[i].user_a, 10))
		segment._references.users.push(parseInt(sorted[i].user_b, 10))
	}
	return sorted
}

export default Segment.extend({
	name: 'compare',
	types: [Constants.TYPE_GROUP],
	detail: ['compare'],
	run: function(type, owner, userIndex, detail, filter, vars) {
		var members = membersCompareAnalysis(owner, userIndex, vars || {})

		if (detail) {
			var user = vars.user ? User.with_id(parseInt(vars.user, 10)) : false
			return {
				username: user ? user.get_name() : false,
				compare: membersComparePackage(this, members, detail, vars.compareType)
			}
		}

		return {
			compare: {
				group: {
					most: membersComparePackage(this, members, detail, 'most'),
					least: membersComparePackage(this, members, detail, 'least')
				}
			}
		}
	}
})
